module.exports = __webpack_public_path__ + "img/symbol_krone@2x.a0f8aa3.jpg";